export var CardName = function (CardName) {
  CardName["PIBA_UK"] = "PIBA UK";
  CardName["PIBA_EU"] = "PIBA EU";
  return CardName;
}({});